<span>{{result$ | async}}</span>